import React from "react";
import ServicePage from "./Components/ServiceComponent";
import mobileDevImage from "../../assets/img/finanjpg.webp"; // Assurez-vous d'avoir une image appropriée
import backgroundMobil from "../../assets/img/technology-1283624_1920.webp";
import {
  FaMobileAlt,
  FaReact,
  FaCode,
  FaRocket,
  FaPaintBrush,
  FaLaptop,
} from "react-icons/fa";
import IntlMessages from "../../intl/IntlMessages";

const MobileDevelopment = () => {
  return (
    <ServicePage
      title={<IntlMessages id="softwareDevelopment.MobilDev" />}
      description={
        <div>
          <p>
            <IntlMessages id="softwareDevelopment.textDescription" />
          </p>
          <p>
            <IntlMessages id="softwareDevelopment.subTextDescription" />
          </p>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <FaMobileAlt size={24} />
              <span style={{ marginLeft: "0.5rem" }}>
                <IntlMessages id="softwareDevelopment.tech" />
              </span>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <FaLaptop size={24} />
              <span style={{ marginLeft: "0.5rem" }}>
                <IntlMessages id="softwareDevelopment.annex" />
              </span>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <FaReact size={24} />
              <span style={{ marginLeft: "0.5rem" }}>
                <IntlMessages id="softwareDevelopment.media" />
              </span>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <FaCode size={24} />
              <span style={{ marginLeft: "0.5rem" }}>
                <IntlMessages id="softwareDevelopment.benefit1" />
              </span>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <FaRocket size={24} />
              <span style={{ marginLeft: "0.5rem" }}>
                <IntlMessages id="softwareDevelopment.benefit2" />
              </span>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <FaPaintBrush size={24} />
              <span style={{ marginLeft: "0.5rem" }}>
                <IntlMessages id="softwareDevelopment.benefit3" />
              </span>
            </div>
          </div>
        </div>
      }
      imageUrl={mobileDevImage}
      altText={<IntlMessages id="softwareDevelopment.altText" />}
      heroBackgroundImage={backgroundMobil}
    />
  );
};

export default MobileDevelopment;
